import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { CreateSlackConfiguration } from '@cast/types';

import { getSlackConfigurationsQueryKey } from 'hooks/queries/notifications/useGetSlackConfigurations';

export const useCreateSlackConfiguration = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (createSlackConfiguration: CreateSlackConfiguration) => {
      return apiClient.notifications.createSlackConfiguration({
        config: createSlackConfiguration,
      });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: getSlackConfigurationsQueryKey() })
        .then(() => {
          notify.success('Slack configuration created successfully');
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
